import { Box, Stack, Typography } from "@mui/material";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CardGoalsProps } from "./CardGoals.types";
import { CardGoalsContainer } from "./CardGoalsContainer";
import { useAchievementsQuery } from "../../queries";
import { TitleTypography } from "../../styles/CommonWidgetStyles/Typography";
import { CommonWidgetContainer, InfoTooltip } from "../Commons/CommonWidgetContainer.styles";

export function CardGoals({ enabled = true, achievements }: { enabled?: boolean } & Partial<CardGoalsProps> = {}) {
  const { t } = useTranslation();

  const {
    data: userAchievements
  } = useAchievementsQuery({ enabled: enabled && !achievements });

  const displayAchievements = achievements || userAchievements;

  if(!displayAchievements || displayAchievements.length === 0) return null;

  return (
    <CommonWidgetContainer hasSidePadding={ false }>
      <Stack
        role={ "region" }
        aria-label={ t("your_goals_title") }
        alignItems={ "center" }
        justifyContent={ "space-between" }
        direction={ "row" }
        gap={ 1 }
      >
        <TitleTypography>{ t("your_goals_title") }</TitleTypography>
        {
          (t("your_goals_title") !== t("your_goals")) ? (
            <InfoTooltip
              arrow
              title={
                <Typography fontSize={ "0.85rem" }>
                  { t("your_goals") }
                </Typography>
              }
            >
              <Box sx={ {
                padding: "0rem 1rem"
              } }>
                <Info size={ 18 }/>
              </Box>
            </InfoTooltip>
          ) : null
        }
      </Stack>
      <CardGoalsContainer achievements={ displayAchievements } />
    </CommonWidgetContainer>
  );
}


